// import { createApp } from 'vue'
// import LibComponents from '../../lib/jin'
// import UIComponents from '../../src/components'

export const Jin = {
  install: (app, options = {}) => {
    if (Jin.installed) return
    Jin.installed = true

    // Vue.prototype 대신 globalProperties 사용
    //app.config.globalProperties.$jin = createApp({}).mount(document.createElement('div'))
    // solution 1: simple object
    app.config.globalProperties.$jin = {}

    // solution 2: reactive object
    // import { createApp, reactive } from 'vue'
    // app.config.globalProperties.$jin = reactive({})

    // 컴포넌트 등록 함수
    const registerComponents = (components) => {
      if (components) {
        for (const key in components) {
          const component = components[key]
          app.component(key, component)
        }
        return true
      }
      return false
    }

    // 전달된 컴포넌트들 등록
    registerComponents(options.components)
  },
  version: 'a/g-3.0.1',
}